import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { FormattedMessage, defineMessages } from 'react-intl';
import * as ApiActions from 'actions/api';
import Layout from 'components/Layout';
const messages = defineMessages({
    title: 'Your email is now confirmed',
});
export default class ConfirmEmail extends Component {
    static fetchData(_, store, { location }) {
        return store.dispatch(ApiActions.checkEmailCode(location.query));
    }
    render() {
        return (_jsxs(Layout, { children: [_jsx(Helmet, { meta: [{ name: 'event-id', content: 'confirm_email' }] }), _jsx(Layout.Container, { children: _jsx("h2", { children: _jsx(FormattedMessage, Object.assign({}, messages.title)) }) })] }));
    }
}
